var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5074 12.4855C23.5074 18.5539 18.3747 23.5077 12 23.5077C5.6253 23.5077 0.49265 18.5539 0.49265 12.4855C0.49265 6.4171 5.6253 1.46335 12 1.46335C18.3747 1.46335 23.5074 6.4171 23.5074 12.4855Z",
    fill: "#30B36B",
    stroke: "#30B36B",
    strokeWidth: 0.9853
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3466 11.4824C15.4707 11.4824 15.5328 11.5445 15.5328 11.6686V12.8418C15.5328 12.9659 15.4707 13.028 15.3466 13.028H12.423C12.3733 13.028 12.3485 13.0528 12.3485 13.1025V15.9702C12.3485 16.0944 12.2864 16.1565 12.1623 16.1565H10.9891C10.8649 16.1565 10.8029 16.0944 10.8029 15.9702V13.1025C10.8029 13.0528 10.778 13.028 10.7284 13.028H7.80477C7.68063 13.028 7.61856 12.9659 7.61856 12.8418V11.6686C7.61856 11.5445 7.68063 11.4824 7.80477 11.4824H10.7284C10.778 11.4824 10.8029 11.4576 10.8029 11.4079V8.42844C10.8029 8.3043 10.8649 8.24222 10.9891 8.24222H12.1623C12.2864 8.24222 12.3485 8.3043 12.3485 8.42844V11.4079C12.3485 11.4576 12.3733 11.4824 12.423 11.4824H15.3466Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.f733a0a50330a7c7b3b0f82a0c32b10b.svg";
export { ForwardRef as ReactComponent };